module.exports = __webpack_public_path__ + "static/media/page_tips_show.8c6e7ae7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/lite/page_tips_show.jpg
// module id = 158
// module chunks = 0